import React from 'react';
import { CssBaseline } from '@mui/material';
import { ThemeProvider as ThemeProviderV5 } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { themeV5 } from '../extensions/mui/theme';

export const ThemeProvider = ({
  children,
  theme = null,
}: {
  children: any;
  theme?: any;
}) => (
  <ThemeProviderV5 theme={theme || themeV5}>
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <CssBaseline />
      {children}
    </LocalizationProvider>
  </ThemeProviderV5>
);
